import { Drawer } from "@mui/material";
import ComplianceSection from "../../Public URL/Sidebar/ComplianceSection";
import DocumentsSection from "../../Public URL/Sidebar/DocumentsSection";
import OtherInfoSection from "../../Public URL/Sidebar/OtherInfoSection";
import OverviewSection from "../../Public URL/Sidebar/OverviewSection";
import QuestionnairesSection from "../../Public URL/Sidebar/QuestionnairesSection";

export const DrawerContent = (props) => {
  const {
    currentSection,
    overviewData,
    complianceData,
    questionnaireData,
    documentsData,
    otherInfoData,
    isDrawerOpen,
    handleDrawerClose,
    triggerIndex,
    publicUrlId
  } = props;

  const renderSectionContent = () => {
    switch (currentSection) {
      case "overview":
        return (
          <OverviewSection
            data={overviewData}
            handleDrawerClose={handleDrawerClose}
          />
        );
      case "complianceAndAudits":
        return (
          <ComplianceSection
            data={complianceData}
            handleDrawerClose={handleDrawerClose}
            triggerIndex={triggerIndex}
            publicUrlId={publicUrlId}
          />
        );
      case "questionnaires":
        return (
          <QuestionnairesSection
            data={questionnaireData}
            handleDrawerClose={handleDrawerClose}
            triggerIndex={triggerIndex}
            publicUrlId={publicUrlId}
          />
        );
      case "documents":
        return (
          <DocumentsSection
            data={documentsData}
            handleDrawerClose={handleDrawerClose}
            triggerIndex={triggerIndex}
            publicUrlId={publicUrlId}
          />
        );
      case "otherInfo":
        return (
          <OtherInfoSection
            data={otherInfoData}
            handleDrawerClose={handleDrawerClose}
            triggerIndex={triggerIndex}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Drawer
      anchor="right"
      open={isDrawerOpen}
      onClose={handleDrawerClose}
      BackdropProps={{
        style: {
          backdropFilter: isDrawerOpen ? "blur(5px)" : "none",
        },
      }}
      PaperProps={{
        sx: {
          width: "50%",
        },
      }}
    >
      {renderSectionContent()}
    </Drawer>
  );
};
